import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import { AbstractDTO } from '../dto/abstract-dto';

export abstract class AbstractForm<TDTO extends AbstractDTO, TService> {
  dto!: TDTO;

  constructor(
    protected service: TService,
    protected route: ActivatedRoute,
    protected alert: AlertService,
    protected router: Router,
  ) {
    this.getData();
  }

  getData(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id === 'novo') {
      return;
    }
    (this.service as any).getById(id).subscribe({
      next: (data: TDTO) => {
        this.dto = data;
        this.afterLoadData();
      },
      error: (err: any) => {
        this.alert.showError('Erro ao buscar os dados.');
        console.error(err);
      },
    });
  }

  protected afterLoadData(): void {}

  protected afterCreate(): void {}

  protected afterUpdate(): void {}

  protected afterError(): void {}

  goList(): void {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  save(): void {
    if ((this.dto as any).id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update(): void {
    (this.service as any).update(this.dto).subscribe({
      next: (data: TDTO) => {
        this.dto = data;
        this.alert.showSuccess('Registro atualizado com sucesso!');
        this.afterUpdate();
      },
      error: (err: any) => {
        console.error(err);
        this.afterError();
      },
    });
  }

  protected create(): void {
    (this.service as any).create(this.dto).subscribe({
      next: (data: TDTO) => {
        this.dto = data;
        this.alert.showSuccess('Registro criado com sucesso!');
        this.router.navigate(['../', data.id], { relativeTo: this.route });
        this.afterCreate();
      },
      error: (err: any) => {
        console.error(err);
        this.afterError();
      },
    });
  }

  isNew(): boolean {
    const id = this.route.snapshot.paramMap.get('id');
    return id == 'novo';
  }
}
